import background from "../../../images/bg_index.png";
import {ThemeProvider} from "@mui/material/styles";
import {Typography} from "@mui/material";
import LgHelloService from "../../services/Desktop&Tablet/lgHelloService";
import LgUService from "../../services/Desktop&Tablet/lgUService";
import SunilService from "../../services/Desktop&Tablet/sunilService";
import RaemianService from "../../services/Desktop&Tablet/raemianService";
import BlaubitService from "../../services/Desktop&Tablet/blaubitService";
import React, {useContext} from "react";
import {MainContext} from "../../../context";


export default function BeforeLoginTablet(props){

    const {theme} = props

    const { toggleClose } = useContext(MainContext)
    return(
        <>
            <div style={{backgroundImage:`url(${background})`, backgroundSize:"cover", paddingBottom:500 }}
            onClick={toggleClose}>
                <div style={{display: 'flex',
                    alignItems: "center",paddingLeft:50,flexDirection:"column"}}>
                    <div className="jumbotron">
                        <div className="font-background">
                            <img alt="No images" src="images/text_slogan.png" style={{
                                marginTop:150,
                                display: 'flex',
                                alignItems:"center",
                                width:'620px',
                                height:'130px',
                                paddingBottom:200
                            }} />
                            <div style={{display: 'flex',
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                                <ThemeProvider theme={theme}>
                                    <Typography  color='white' component="h3" variant="h7" sx={{marginTop:5}}>
                                        고객사 전용 회원가입 서비스입니다.
                                    </Typography>
                                    <div style={{alignItems: "center", display: "flex", marginTop:5}}>

                                        <LgHelloService/>
                                        <div style={{width: 15}}></div>
                                        <LgUService/>
                                        <div style={{width: 15}}></div>
                                        <SunilService/>

                                    </div>
                                    <div style={{alignItems: "center", display: "flex", marginTop:5}}>
                                        <RaemianService/>
                                        <div style={{width: 15}}></div>
                                        <BlaubitService/>
                                        <div style={{width: 15}}></div>
                                    </div>
                                    <div style={{height:180}}></div>
                                </ThemeProvider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}